// Material Dashboard 2 React example components
import DataTable from "examples/Tables/DataTable";

// Material Dashboard 2 React components
import MDTypography from "components/MDTypography";

// prop-types is a library for typechecking of props.
import PropTypes from "prop-types";
import { useSelector } from "react-redux";
import { useEffect, useState } from "react";

const columns = [
  { Header: "Libellé", accessor: "wording", align: "center" },
  { Header: "Déscription", accessor: "description", align: "left" },
  { Header: "Catégories", accessor: "tags", align: "left" },
  { Header: "Prix", accessor: "price", align: "center" },
  { Header: "Provenance", accessor: "provenance", align: "center" },
];

function CoursesUserTableData({ userId }) {
  const courses = useSelector((state) => state.course.allCourses);
  const [currentCourses, setCurrentCourses] = useState([]);
  const getCourses = () => {
    const cours = courses.filter((c) => c.subscriptions.some((s) => s.client.id === userId));
    setCurrentCourses(cours);
  };
  useEffect(() => {
    getCourses();
  }, [courses]);

  const rows = currentCourses.map((course) => ({
    wording: (
      <MDTypography variant="caption" color="text" fontWeight="medium">
        {course.wording}
      </MDTypography>
    ),
    description: (
      <div style={{ maxWidth: 200 }}>
        <MDTypography variant="caption" color="text" fontWeight="medium">
          {course.description}
        </MDTypography>
      </div>
    ),
    tags: (
      <div style={{ maxWidth: 200 }}>
        {course.tags.map((tag) => (
          <MDTypography key={tag} variant="caption" color="text" fontWeight="medium">
            {tag.wording}
          </MDTypography>
        ))}
      </div>
    ),
    price: (
      <div style={{ maxWidth: 350 }}>
        <MDTypography variant="caption" color="text" fontWeight="medium">
          {`${course.price} toges`}
        </MDTypography>
      </div>
    ),
    provenance: (
      <MDTypography variant="caption" color="text" fontWeight="medium">
        {course.subscriptions.find((s) => s.client.id === userId).provenance !== null
          ? course.subscriptions.find((s) => s.client.id === userId).provenance
          : ""}
      </MDTypography>
    ),
  }));

  return (
    <DataTable
      table={{ columns, rows }}
      isSorted={false}
      entriesPerPage={false}
      showTotalEntries={false}
      noEndBorder
    />
  );
}

CoursesUserTableData.propTypes = {
  userId: PropTypes.number.isRequired,
};

export default CoursesUserTableData;
